<template>
  <div class="pagination">
    <button
      id="prev"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
    >
      <TreeCardIcon
        src="/dashboard/leftArrow.svg"
        alt="leftArrow"
        custumeIconsClass
      />
    </button>
    <template v-if="totalPageCount <= 3">
      <button
        v-for="page in totalPageCount"
        :key="page"
        :class="{page: true, active: page === currentPage}"
        @click="changePage(page)"
      >
        {{ page }}
      </button>
    </template>

    <template v-else>
      <!-- Always show first page -->
      <button
        :class="{page: true, active: 1 === currentPage}"
        @click="changePage(1)"
      >
        1
      </button>
      <!-- Show ellipsis or second page -->
      <template v-if="currentPage <= 3">
        <button
          :class="{page: true, active: 2 === currentPage}"
          @click="changePage(2)"
        >
          2
        </button>
        <button
          :class="{page: true, active: 3 === currentPage}"
          @click="changePage(3)"
        >
          3
        </button>
        <span class="ellipsis">...</span>
      </template>
      <template v-else-if="currentPage >= totalPageCount - 2">
        <span class="ellipsis">...</span>
        <button
          :class="{page: true, active: totalPageCount - 2 === currentPage}"
          @click="changePage(totalPageCount - 2)"
        >
          {{ totalPageCount - 2 }}
        </button>
        <button
          :class="{page: true, active: totalPageCount - 1 === currentPage}"
          @click="changePage(totalPageCount - 1)"
        >
          {{ totalPageCount - 1 }}
        </button>
      </template>
      <template v-else>
        <span class="ellipsis">...</span>
        <button
          :class="{page: true, active: currentPage - 1 === currentPage}"
          @click="changePage(currentPage - 1)"
        >
          {{ currentPage - 1 }}
        </button>
        <button
          :class="{page: true, active: currentPage === currentPage}"
          @click="changePage(currentPage)"
        >
          {{ currentPage }}
        </button>
        <button
          :class="{page: true, active: currentPage + 1 === currentPage}"
          @click="changePage(currentPage + 1)"
        >
          {{ currentPage + 1 }}
        </button>
        <span class="ellipsis">...</span>
      </template>
      <!-- Always show last page -->
      <button
        :class="{page: true, active: currentPage === totalPageCount}"
        @click="changePage(totalPageCount)"
      >
        {{ totalPageCount }}
      </button>
    </template>
    <button
      id="next"
      :disabled="currentPage === totalPageCount"
      @click="changePage(currentPage + 1)"
    >
      <TreeCardIcon
        src="/dashboard/rightArrow.svg"
        alt="rightArrow"
        custumeIconsClass
      />
    </button>
  </div>
</template>
<script>

import TreeCardIcon from '@/components/component/icons/TreeCardIcon.vue';

export default {
    name: 'UnbilledWorkOrderFooter',
    components: { TreeCardIcon },
    props: {
        currentPage: {
            type: Number,
            default: () => null,
        },
        totalPageCount: {
            type: Number,
            default: () => null,
        },
        isFirstTab: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        totalPageCount: {
            handler(val) {
                if ((val <= 1 || this.currentPage === val) && this.isFirstTab) {
                    this.changePage(1);
                }
            },
        },
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page);
        },
    },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/components/unbilliedWoStyle";
</style>
